module.exports = __webpack_public_path__ + "static/media/stage.ffb1f742.svg";